import React, { type ComponentProps } from 'react';

import Loadable from 'react-loadable';
// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazy, LazySuspense } from 'react-loosely-lazy';

import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { BrowseRovoAgentsModalProps } from './index';

const BrowseRovoAgentsModalLazyComponent = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_editor-ai-browse-rovo-agents-modal" */
			'./index'
		).then((mod) => mod.default) as Promise<
			React.ComponentType<React.PropsWithChildren<BrowseRovoAgentsModalProps>>
		>,
);

const BrowseRovoAgentsModalLoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_editor-ai-browse-rovo-agents-modal" */
			'./index'
		).then((mod) => mod.default) as Promise<
			React.ComponentType<React.PropsWithChildren<BrowseRovoAgentsModalProps>>
		>,
	loading: () => null,
});

function BrowseRovoAgentsModalWithLazySuspense(
	props: ComponentProps<typeof BrowseRovoAgentsModalLazyComponent>,
) {
	return (
		<LazySuspense fallback={null}>
			{/* eslint-disable-next-line react/jsx-props-no-spreading */}
			<BrowseRovoAgentsModalLazyComponent {...props} />
		</LazySuspense>
	);
}

export const BrowseRovoAgentsModal: React.ComponentType<
	React.PropsWithChildren<BrowseRovoAgentsModalProps>
> = (props) => {
	if (isExperimentEnabled('platform_editor_loosely_lazy_migration')) {
		// eslint-disable-next-line react/jsx-props-no-spreading
		return <BrowseRovoAgentsModalWithLazySuspense {...props} />;
	}

	// eslint-disable-next-line react/jsx-props-no-spreading
	return <BrowseRovoAgentsModalLoadableComponent {...props} />;
};

export const PreloadModalComponent = () => {
	React.useEffect(() => {
		if (isExperimentEnabled('platform_editor_loosely_lazy_migration')) {
			BrowseRovoAgentsModalLazyComponent.preload();
		} else {
			BrowseRovoAgentsModalLoadableComponent.preload();
		}
	}, []);

	return null;
};
